const DataNotFound = (props) => {
  return (
    <div className={`data-not-found ${props?.className || ''}`}>
      {props?.message ? <h1>{props?.message} </h1> : <h1>{props.title ? (props.nochange ? props?.title : `No ${props?.title}s`) : 'No Data Found'} </h1>}
    </div>
  );
};

export default DataNotFound;
